<template>
  <br />
  <div class="oddRoundElement">
    <p class="textTitalIndentation">尊敬的用户：</p>
    <p class="text2DIndentation">您好！欢迎使用镖计划（域名：global-bplan.net；以下简称“平台”）！您的信任对【镖计划项目组】（以下简称“我们”）非常重要，我们深知用户隐私信息对您的重要性，为此我们将按法律法规要求，恪守权责一致、目的明确、选择同意、最小必要、确保安全、主体参与、公开透明的原则，采取相应安全保护措施，尽力保护您的信息安全可控。请您仔细阅读《隐私及信息保护政策》（特别是加粗字体的内容，以下简称“本隐私政策”），并确定了解我们对您的信息的保护和处理规则。您一旦点击或勾选同意本隐私政策，即意味着同意我们按照本隐私政策收集、使用、储存和共享您的相关信息。本隐私政策中涉及的相关术语，我们用简明扼要的表述，以便您更好地理解。在我们更新本隐私政策后，您阅读并同意接受更新的版本与内容，即意味着您同意我们按照更新后的隐私政策收集、使用、保存和共享您的相关信息。如果您不接受更新后的上述文件相关内容，原交易项下其权利义务不变，但您应及时停止使用本平台，不得开展后续其他交易并及时通过平台公布的联系方式与我们取得联系。</p>
    <p class="text2DIndentation">本隐私政策仅适用于平台运营方直接提供的产品/服务，如您通过其他途径进入本平台或通过平台进入其他主体运营的网页/客户端/链接并提供您的用户信息，我们建议您仔细阅读并查看他们的隐私政策，以便了解他们如何处理您的信息，保护您的权利。</p>
    <p class="textIndentation">本隐私政策将帮助你了解以下内容：</p>
    <p class="textIndentation">一． 我们如何收集您的信息</p>
    <p class="textIndentation">二． 我们如何存储您的信息（含 cookie 技术）</p>
    <p class="textIndentation">三． 我们如何保护您的信息</p>
    <p class="textIndentation">四． 我们如何使用您的信息</p>
    <p class="textIndentation">五． 信息的分享和对外提供</p>
    <p class="textIndentation">六． 您的信息权利</p>
    <p class="textIndentation">七． 敏感信息</p>
    <p class="textIndentation">八． 未成年人保护</p>
    <p class="textIndentation">九． 政策变更</p>
    <p class="textIndentation">十． 如何联系我们十一</p>
    <p class="textIndentation">其他</p>
    <p class="text2DIndentation">相关定义：您/用户：通过平台申请服务的企业用户或个人用户，包括自然人、法人或其他组织。</p>
    <p class="textTitalIndentation"><strong>一、	我们如何收集您的信息</strong></p>
    <p class="textIndentation">我们会通过如下三种渠道获取您的信息：</p>
    <p class="textIndentation">1.您直接提供的信息：我们可能收集并存储您在使用平台服务时向我们提供的信息，包括但不限于您在我们页面中在线填写信息时、申请平台服务时、解决争议或就平台服务与我们联系时所提供的信息，以及您在使用我们平台服务过程中产生的关于您的交易和活动的信息。</p>
    <p class="textIndentation">2.我们主动收集的信息：在您使用平台网站、APP 及相关服务过程中，我们会收集您的计算机、手机及其他访问设备发送给我们的信息。</p>
    <p class="textIndentation">3.我们从其他来源取得的信息：在取得您同意或第三方有权提供的前提下，我们还可能从我们关联公司、经国务院或其他政府有权机关批准合法设立的机构、数据信息机构、公安、公积金、社保、税务、民政、物流、通信运营商、电子商务平台、互联网平台、资信评估机构等合法留存您信息的第三方机构获取您的相关信息。</p>
    <p class="text2DIndentation">(二)我们可能收集的信息</p>
    <p class="text2DIndentation">为实现向您提供我们的产品及/或服务的基本功能，您须授权我们收集、使用的必要的信息。如您拒绝提供相应信息，您将无法正常使用我们的产品及/或服务；</p>
    <p class="text2DIndentation">为实现向您提供我们产品及/或服务的附加功能，您可选择授权我们收集、使用的信息。如您拒绝提供，您将无法正常使用相关附加功能或无法达到我们拟达到的功能效果，但并不会影响您正常使用我们产品及/或服务的基本功能。</p>
    <p class="text2DIndentation">您理解并同意：根据用户需求的不同，用户选择使用我们具体产品/服务的范围存在差异，相应的，我们提供的基本/附加功能及须收集使用的用户个人信息类型、范围等会有所区别我们提供的产品或服务会不时更新或优化，可能需要收集、使用新的个人信息或变更个人信息使用目的或方式。对此，我们将通过更新本隐私改策、弹窗、页面提示等方式另行向您说明对应信息的收集目的、范围及使用方式，并为您提供自主选择同意的方式，且在征得您明示同意后收集、使用。</p>
    <p class="text2DIndentation">1.账户绑定/注册的信息的收集：</p>
    <p class="text2DIndentation">用户需要绑定/注册成为会员以便于使用我们的提供的服务，您需要提供手机拟使用的会员名、用户昵称和密码、用户头像、性别、密码保护选项、电子邮箱、联系地址、联系电话信息用于注册账户。我们可能会要求您提供、身份证号、出生日期、婚姻状况、家庭住址、工作单位等信息并校验您的会员身份，确保我们是在为您本人提供服务。具体而言包括如下信息类别与用途：</p>
    <p class="textIndentation">(1)个人信息：姓名、身份证号码及有效期、电子邮件地址、电话号码、联系地址、微信相关信息（包括但不限于微信号、微信昵称、OpenID）等，若通过生物识别信息核验等方式进一步确认您提供信息的准确性时，我们还需要您提供面部图像/视频。我们会将上述信息提交给合法持有您上述信息的第三方身份验证机构，以便对您所提供信息的准确性进行核对。如果您不提供上述信息或您的身份验证未通过，则平台可能无法正常提供全部或部分服务。</p>
    <p class="textIndentation">(2)实名认证：您可以根据认证要求提供相应的身份信息身份证、护照、户口本及其他身份证件信息）、生物识另特征（静态或动态的面部特征）视频录像、音频验证等几种方式用于完成实名认证。我们为您提供的实名认证服务系由与我们及/或关联公司合作的第三方提供具体服务且需要将您上述信息、图片、视频、音频文件提供至第三方服务机构，您在使用此项服务时，请务必仔细阅读第三方的服务规则以及服务所需个人信息的授权内容，以充分保证您的合法权益不受侵犯。</p>
    <p class="textIndentation">(3)授权登录：我们可能经您同意后向第三方共享您的账户信息（头像、昵称及其他页面提示的信息），使您可以便捷地实现第三方账户的注册或登录。此外，我们可能会根据您的授权从第三方处获取您的账户信息，并与您在我们平台账户进行绑定，使您可通过第三方账户直接登录、使用我们的产品及/或服务。如您通过第三方账户登录、使用我们的产品及/ 或服务，我们建议您仔细阅读第三方服务提供方的隐私政策和用户协议，我们无法对该等第三方平台如何处理您的个人信息做出任何承诺。</p>
    <p class="text2DIndentation">2.为保障交易安全所必须的功能：</p>
    <p class="text2DIndentation">提供商品或服务信息展示在您使用我们服务过程中，为识别账号异常状态、了解产品或服务的内容，我们可能会自动收集您的使用情况并存储为网络日志信息，包括：</p>
    <p class="textIndentation">(1)设备信息：我们会根据您在软件安装及/或使用中的具体操作，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、设备设置、唯一设备标识符、设备环境等软硬件特征信息）、设备所在位置相关信息（包括您授权的 GPS 位置以及 WLAN 接入点、蓝牙和基站等传感器信息），用于向您提供我们的保证网络安全或运营安全。</p>
    <p class="textIndentation">(2)服务日志信息：当您使用我们的网站或客户端提供的产品或服务时，我们会自动收集您对我们服务的详细使用情况，作为服务日志保存，包括浏览、点击查看、搜索查询交易、关注分享信息、发布信息，以及 IP 地址、浏览器类型、电信运营商、使用语言、访问日期和时间。</p>
    <p class="text2DIndentation">请注意，单独的设备信息、服务日志信息是无法识别特定自然人身份的信息。如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将这类信息做匿名化、去标识化处理为向您提供更便捷、更符合您个性化需求的信息展示、搜索及推送服务，我们会根据您的设备信息和服务日志信息，提取您的偏好特征，并基于特征标签产岀间接人群画像，用于展示、推送信息和可能的商业广告（如有）。</p>
    <p class="textIndentation">我们还可能为了提供服务及改进服务质量的合理需要而收集用户的其他信息，包括用户与我们的客户服务团队联系时提供的相关信息，用户参与问卷调查时向我们发送的问卷答复信息。与此同时，为提高用户使用平台服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会通过了解一些用户的网络使用习惯等手段来判断用户账户的风险。</p>
    <p class="text2DIndentation">3.其他附加服务所需设备权限：</p>
    <p class="text2DIndentation">为向您提供更优质的产品及/或服务，努力提升您的体验，我们在向您提供的以下附加服务中可能会收集和使用您的个人信息。如果您不提供这些信息，不会影晌您使用镖计划产品的浏览、搜索等基本服务，但您可能无法获得这些附加服务给您带来的用户体验。这些附加服务您未确认使用的情况下不会开启包括：</p>
    <p class="textIndentation">(1)基于相机/摄像头的附加服务：您可在开启相机/摄像头权限后使用该功能进行扫码用于登录、领取优惠信息，拍摄照片、音频或视频用于评价、分享，以及特定场景下经您授权的人脸识别等功能。当您使用该附加功能进行人脸识别时我们会收集您的面部特征信息。</p>
    <p class="textIndentation">(2)基于相册（图片库/视频库/音频库）的图片/视频/音频访问及上传的附加服务：您可在开启相册权限后使用该功能上传您的照片/图片/视频/音频，以实现更换头像、在电台频道发表评论/分享、拍照等功能。我们可能会通过您所上传的图片/视频/音频来识别您所表达的内容，或使用包含您所上传图片/视频/音频的评论信息。</p>
    <p class="text2DIndentation">您理解并同意，上述附加服务可能需要您在您的设备中开启您的摄像头（相机）、相册（图片库）的访问权限，以实现这些权限所涉及信息的收集和使用。您可在您的设备设置或我们客户端中逐项查看上述权限的状态，并可自行决定这些权限随时的开启或关闭。请您注意，您开启任一权限即代表您授权我们可以收集和使用相关个人信息来为您提供对应服务，您一旦关闭任一权限即代表您取消了授权，我们将不再基于对应权限继续收集和使用相关个人信息，也无法为您提供该权限所对应的服务。但是，您关闭权限的决定不会影响此前基于您的授权所进行的信息收集及使用。</p>
    <p class="text2DIndentation">(三)您充分知晓，以下情形中，我们收集、使用您的信息无需征得您的授权同意</p>
    <p class="textIndentation">1.与国家安全、国防安全直接有关的；</p>
    <p class="textIndentation">2.与公共安全、公共卫生、重大公共利益直接有关的；</p>
    <p class="textIndentation">3.与犯罪侦查、起诉、审判和判决执行等直接有关的；</p>
    <p class="textIndentation">4.出于维护信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</p>
    <p class="textIndentation">5.所收集的信息是信息主体自行向社会公众公开的；</p>
    <p class="textIndentation">6.从合法公开披露的信息中收集的您的信息的；</p>
    <p class="textIndentation">7.根据您的要求签订和履行合同所必需的；</p>
    <p class="textIndentation">8.用于维护所提供的平台服务的安全稳定运行所必需的，例如发现、处置服务的故障；</p>
    <p class="textIndentation">9.学术研究机构基于公共利益开展统计或学术研究所必要；</p>
    <p class="textIndentation">10.保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身和财产安全或合法权益所合理必需的用途；</p>
    <p class="textIndentation">11.法律法规规定的其他情形。</p>
    <p class="textTitalIndentation">(四)我们将以如下规则处理和使用前述收集的您的信息：</p>
    <p class="textIndentation">1.我们会根据本隐私政策的约定并为实现我们的产品与或服务功能对所收集的用户信息进行使用。</p>
    <p class="textIndentation">2.在收集您的用户信息后，我们将通过技术手段对数据进行去标识化处理，去标识化处理的信息将无法识别主体。</p>
    <p class="textIndentation">3.请您了解并同意，在此情况下我们有权使用已经去标识化的数据库进行分析并予以商业化的利用（如数据分析、用户画像等）。</p>
    <p class="textIndentation">4.请您注意，您在使用我们的产品与/或服务时所提供的所有用户信息，除非您删除或通过系统设置拒绝我们收集否则将在您使用我们的产品与/ 或服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除您的用户信息。</p>
    <p class="textIndentation">5.我们会对我们的产品与/或服务使用情况进行统计，并可能会与公众或第三方共享这些统计信息，以展示我们的与/或服务的整体使用趋势。但这些统计信息不包含您的任何身份识别信息。</p>
    <p class="textIndentation">6.当我们展示您的用户信息时，我们会采用包括内容替换、匿名处理方式对您的信息进行脱敏，以保护您的信息安全</p>
    <p class="textIndentation">7.当我们要将您的用户信息用于本隐私政策未载明的其它用途时，或基于特定目的收集而来的信息用于其他目的时，会通过您主动做出勾选的形式事先征求您的同意。</p>
    <p class="textTitalIndentation"><strong>二、我们如何存储您的信息</strong></p>
    <p class="textIndentation">(一)本地存储：我们可能会使用设备存储等机制和应用数据缓存等途径，收集您设备上的信息（包括个人信息、企业信息等）以及您在使用我们产品或服务时向我们提供的信息，并进行本地存储。您提供的信息将留存于中华人民共和国境内（为本协议之目的，不包含中国香港特别行政区、澳门特别行政区和台湾地区）。我们会依照个人信息的不同等级存储不同期限，存储期限严格按照法律及相关法规规定，最低期限不少于 6 个月。</p>
    <p class="textIndentation">(二)加密存储技术：我们向您收集的信息都将通过较高级别的信息安全手段将您的信息加密存储在专门服务器中。</p>
    <p class="textTitalIndentation"><strong>三、我们如何保护您的信息</strong></p>
    <p class="textIndentation">1.采用符合业界标准的安全防护措施以及行业内通行的安全技术来保护您的信息。</p>
    <p class="textIndentation">2.建立专门的管理制度、流程和组织以保障信息的安全。</p>
    <p class="textIndentation">3.制定与信息安全相关的网络安全事件应急预案，及时处置平台漏洞、计算机病毒、网络攻击、网络侵入等安全风险。</p>
    <p class="textIndentation">4.我们通过建立数据分类分级制度、数据安全管理规范数据安全开发规范来管理规范用户信息的存储和使用。</p>
    <p class="textIndentation">5.采取合理可行的措施，尽力避免收集无关的信息。我们只会在达成本隐私政策所述目的所需的期限内保留您的用户信息，除非需要延长保留期或受到法律的允许。</p>
    <p class="textIndentation">6.但请您理解，由于技术的限制以及可能存在的各种恶意手段，在互联网行业，即便竭尽所能加强安全措施，也不可能始终保证信息百分之百的安全。您需要了解，您接入我们的服务所用的平台和通讯网络，有可能因我们可控范围外的因素而出现问题。</p>
    <p class="textIndentation">7.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
    <p class="textTitalIndentation"><strong>四、我们如何使用您的信息</strong></p>
    <p class="text2DIndentation">我们可能将我们于本隐私政策项下所收集、存储的您的信息用作下列用途：</p>
    <p class="textIndentation">1.向您提供服务。</p>
    <p class="textIndentation">2.在我们提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份等用途，确保我们向您提供的产品和服务的安全性。</p>
    <p class="textIndentation">3.帮助我们完善现有的服务，开发新的功能以为您提供更好的服务。</p>
    <p class="textIndentation">4.我们可能会将来自某项服务的您的信息与来自其他我们或我们的关联公司提供服务的信息结合起来，以为您提供更为全面的、更为优质的服务。</p>
    <p class="textIndentation">5.为您推荐服务，开展市场调查与信息数据分析。</p>
    <p class="textIndentation">6.根据平台为您提供的产品/服务的内容，我们可能需要即时与您保持联系，我们的客户服务人员需要利用您提供的信息向您发送与服务相关的通知提醒（如：服务到期提醒），并在收到您的投诉时再次与您核实您的信息以便更快速的解决您的问题。</p>
    <p class="textIndentation">7.为了让您有更好的体验、改善我们的服务或您同意的其他用途，在符合相关法律法规的前提下，我们可能将通过某一项服务所收集的信息，以汇集信息或者个性化的方式，用于我们的其他服务。</p>
    <p class="textIndentation"><strong>五、信息的分享和对外提供</strong></p>
    <p class="text2DIndentation">(一)信息共享的原则</p>
    <p class="textIndentation">1.授权同意原则：未经您的同意，我们不会共享您的个人信息，除非共享的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。如果第方使用信息的目的超越原授权同意范围，他们需要重新征得您的同意。</p>
    <p class="textIndentation">2.合法正当与最小必要原则：共享的数据必须具有合法正当目的，且共享的数据以达成目的必要为限。</p>
    <p class="textIndentation">3.安全审慎原则：我们将审慎评估第三方使用共享信息的目的，对这些合作方的安全保障能力进行综合评估，并要求其遵循与我们签署的合作协议。</p>
    <p class="text2DIndentation">(二)您知晓并同意，在以下情形下，我们可能会向我们的关联公司、合作伙伴及/或第三方共享、转让或披露您的信息（含敏感信息）：</p>
    <p class="textIndentation">1.我们可能将您的信息与我们的关联公司、合作伙伴（可能会包括银行、信托、保理公司等拟为您提供融资服务的机构）及第三方服务供应商、承包商及代理商共享，用于下列用途：</p>
    <p class="textIndentation">(1)向您提供我们的及我们关联公司、合作伙伴的产品及服务；</p>
    <p class="textIndentation">(2)实现本隐私政策第四部分（“四.我们如何使用您的信息”）所述目的；</p>
    <p class="textIndentation">(3)履行我们在本隐私政策中的义务和行使我们在本隐私政策项下的权利；</p>
    <p class="textIndentation">(4)为了协助解决您与我们以及我们的关联公司、合作伙伴之间就交易产生的纠纷；</p>
    <p class="textIndentation">(5)理解、维护和改善我们的服务。</p>
    <p class="text2DIndentation">具体而言，我们将可能与如下授权合作伙伴共享、转让或披露您的信息</p>
    <p class="textIndentation">（a）分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息与提供给分析服务的合作伙伴共享。我们会委托这些合作伙伴处理与您服务需求相关的信但不会提供您的个人身份信息，或者我们将这些信息进行去标识化处理，以便它不会识别您个人。这类合作伙伴可能将上述信息与他们合法获取的其他数据相结合，以执行我们委托的服务或决策建议。</p>
    <p class="textIndentation">（b）服务提供方和其他合作伙伴。我们将信息发送给支持我们业务的服务提供方和其他合作伙伴，这些支持包括受我们委托提供的技术基础设施服务、分析我们服务的使用方式、验证用户注册信息的真实性、验证身份信息和征信信息、衡量服务的有效性、提供客户服务、支付功能或进行学术研究和调查。</p>
    <p class="textIndentation">我们会对授权合作伙伴获取有关信息的应用程序接口 API、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</p>
    <p class="textIndentation">2.随着我们业务的持续发展，我们有可能进行合并、收购、资产转让或类似的交易，您的信息有可能作为此类交易的一部分而被转移。我们将在转移前通知您，并会要求该等接收您的信息的主体继续受本隐私政策的约束，否则我们将要求该等主体重新向您征求授权同意。</p>
    <p class="textIndentation">3.平台提供的产品或服务可能由第三方提供或由我们与第三方联合提供，我们必须将与交易有关的必要信息与第三方机构共享来实现为您提供良好服务的需求。用户的交易相对方以及访问的第三方网站经营者、用户使用的第三方提供者和通过我们获取用户的个人信息的第三方可能有自己的隐私权保护政策以及获取用户个人信息的方法和措施，这些第三方的隐私权保护政策、获取个人信息的方法和措施将不会受到我们的控制。虽然我们将与可能接触到您的个人信息的合作方及供应商等第三方签署合作协议并尽合理的注意义务督促其履行保密义务，但我们无法保证第三方一定会按照要求采取保密措施，因此我们不对第三方的违约行为及后果承担责任。</p>
    <p class="textIndentation">4..在不透露单个用户隐私资料或在取得相关用户的授权的前提下，我们及我们委托的关联公司及/或合作伙伴有权对整个用户数据库进行推演、计算、分析、梳理、挖掘应用，并在此基础上对用户数据库加以利用。我们保证不会在未经相关用户同意的前提下对外公开或向第三方提供单个用户的注册资料及用户在使用网络服务时存储在我们处的非公开内容。</p>
    <p class="textIndentation">5.经您事先明确的同意或授权，我们可能与我们的关联公司、合作伙伴及/ 或第三方分享您的信息。我们将以点击确认本隐私政策或相应授权等形式征求您的同意（具体形式以实际场景为准）。</p>
    <p class="textIndentation">6.我们仅会在以下情况下，公开披露您的个人信息：</p>
    <p class="textIndentation">(1)获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</p>
    <p class="textIndentation">(2)如果我们确定您岀现违反法律法规或严重违反本协议的情况，或为使我们平台用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及对您采取的措施。</p>
    <p class="textIndentation"><strong>六、	您的信息权利</strong></p>
    <p class="textIndentation">按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：</p>
    <p class="textIndentation">(一)访问您的个人信息 您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使您的用户信息或在使用我们的产品或服务过程中的产生的其他信息的数据访问权，您可通过本政策指引与我们取得联系。</p>
    <p class="textIndentation">(二)更正您的个人信息 当您发现我们处理的关于您的个人信息有错误时，您有权要求我们作出更正。我们将在 30 天内回复您的更正请求。</p>
    <p class="textIndentation">(三)删除您的个人信息 在以下情形中，您可以向我们提出删除个人信息的请求：</p>
    <p class="textIndentation">1.如果我们处理个人信息的行为违反法律法规；</p>
    <p class="textIndentation">2.如果我们收集、使用您的个人信息，却未征得您的同意；</p>
    <p class="textIndentation">3.如果我们处理个人信息的行为违反了与您的约定；</p>
    <p class="textIndentation">4.如果您不再使用我们的产品或服务，或您注销了账号；</p>
    <p class="textIndentation">5.如果我们不再为您提供产品或服务。 若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。</p>
    <p class="textIndentation">当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>
    <p class="textIndentation">(四)改变您授权同意的范围 每个业务功能需要一些基本的个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。</p>
    <p class="textIndentation">(五)当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。 如果您不想接受我们给您发送的商业广告，您随时以本政策第十条及平台公布的方式联系我们取消：</p>
    <p class="textIndentation">(六)个人信息主体注销账户 您随时可注销此前注册的账户，在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息，法律法规另有规定的除外。</p>
    <p class="textIndentation">(七)个人信息主体获取个人信息副本 您有权获取您的个人信息副本，在技术可行的前提下，如数据接口已匹配，我们还可按您的要求，直接将您的个人信息副本传输给您指定的第三方。</p>
    <p class="textIndentation">(八)约束信息系统自动决策 在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制作出决定。如果这些决定显著影响您的合法权益，您有权要求我们作出解释，我们也将提供适当的救济方式。</p>
    <p class="textIndentation">(九)响应您的上述请求 为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。
我们将在三十天内作出答复。</p>
    <p class="textIndentation">对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
    <p class="textIndentation">(十)在以下情形中，我们将无法响应您的请求：</p>
    <p class="textIndentation">1.与个人信息控制者履行法律法规规定的义务相关的；</p>
    <p class="textIndentation">2.与国家安全、国防安全直接相关的；</p>
    <p class="textIndentation">3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
    <p class="textIndentation">4.与刑事侦查、起诉、审判和执行判决等直接相关的；</p>
    <p class="textIndentation">5.个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥 用权利的；</p>
    <p class="textIndentation">6.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但 又很难得到本人同意的；</p>
    <p class="textIndentation">7.响应个人信息主体的请求将导致个人信息主体或其他个人、组织的 合法权益受到严重损害的；</p>
    <p class="textIndentation">8.涉及商业秘密的。</p>
    <p class="textIndentation"><strong>七、敏感信息</strong></p>
    <p class="textIndentation">某些您的信息因其特殊性可能被认为是个人敏感信息，例如您个人的银行账号、财产信息、征信信息、身份证件号码、交易信息、税务信息、个人生物识别信息等。相比其他信息，个人敏感信息受到更加严格的保护，我们尽最大努力确保该等数据接收方应具备充分的信息安全保障能力。</p>
    <p class="textIndentation"><strong>八、未成年人保护</strong></p>
    <p class="textIndentation">我们非常重视对未成年人个人信息的保护。我们的产品与/或服务仅面向成人或企业。若您是 18 周岁以下的未成年人，在使用我们的产品与/或服务前，应事先取得您的法定监护人的书面同意。对于经监护人同意而收集儿童个人信息的情况，我们只会在受到法律允许、监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。如果我们在未事先获得可证实的法定监护人同意的情况下收集了儿童的个人信息，或儿童的监护人撤回其同意的，则会设法尽快删除相关数据。若您是未成年人的法定监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过第十条中的联系方式与我们联系。</p>
    <p class="textIndentation"><strong>九、政策变更</strong></p>
    <p class="textIndentation">我们可能适时修订本隐私政策的有关条款，该等修订构成本隐私政策的一部分。在我们更新本隐私政策后您继续使用我们的平台，即意味着您同意本隐私政策(含更新版本)内容，并且同意我们按照本更新后的隐私政策收集、使用、保存和共享您的相关信息。如您不接受更新后的隐私政策，请您及时暂停使用本产品与/或服务，并与我们取得联系。</p>
    <p class="textIndentation"><strong>十、如何联系我们</strong></p>
    <p class="textIndentation">如果您对本隐私政策或我们的数据处理有任何疑问、意见或建议，可以通过我们提供的各种联系方式与我们联系。我们的联系方式如下：联系方式：zaozhixin2030@126.com</p>
    <p class="textIndentation">一般情况下，我们将在收到您相关联系信息后十五天内回复。</p>
    <p class="textIndentation"><strong>十一、其他</strong></p>
    <p class="textIndentation">1.本隐私政策的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（就本协议之目的，不包含中国香港特别行政区、澳门特别行政区和台湾地区的法律）。</p>
    <p class="textIndentation">2.如就本隐私政策的解释或执行发生争议，双方应首先力争通过友好协商解决该争议。如果在一方向其他方送达要求开始协商的书面通知后六十天内未能通过协商解决争议，那么任何一方均可向平台服务器所在地（即北京市朝阳区酒仙桥北路 9 号）有管辖权的人民法院起诉。当任何争议发生时以及在对任何争议进行诉讼时，除争议事项外，各方应继续行使各自在本隐私政策项下的其他权利，履行各自在本隐私政策项下的其他义务。</p>
    <p class="textIndentation">3.本隐私政策是我们就向您提供产品或服务时发布的《用户服务协议》等相关协议的组成部分，与其构成一个统一的整体。</p>
    <p class="textIndentation">4.如本隐私政策中的任何条款因任何原因被判定为完全或部分无效或不具有执行力，本隐私政策的其余条款仍应有效并且有执行力。</p>
    <!--van-divider :style="{ color: '#EA6853', borderColor: '#EA6853', padding: '0 16px' }"></van-divider>
        <van-row>
              <van-col offset="1" span="9"><van-checkbox v-model="state.Informed.informedFlag">我已经仔细阅读并同意上述内容</van-checkbox></van-col>
        </van-row-->
    <br />
  </div>
  <br />

  <van-button round color="linear-gradient(to right, #f67f34, #d55809)" size="large" @click="changeInformed">返回</van-button>

  <van-overlay :show="showOverlay" @click="showOverlay = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar wrapable :scrollable="false" text="您未做机构绑定" left-icon="info-o" />
          <p class="textIndentationoverlay"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
              background="#ffffff" text="目前仅开放体检机构定向邀约客户绑定。您可以向体检机构获取【邀约码】。" /></p>
          <van-button type="warning" block plain hairline to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
  <van-overlay :show="showBinging" @click="showBinging = false">
    <div class="wrapper" @click.stop>
      <div class="block">
        <van-cell-group inset>
          <van-notice-bar wrapable :scrollable="false" text="绑定确认中" left-icon="info-o" />
          <p class="textIndentationoverlay"><van-notice-bar wrapable :scrollable="false" color="#1989fa"
              background="#ffffff" text="您提交的绑定需要【3-5个工作日】确认" /></p>
          <van-button type="warning" block plain hairline to="about">
            返回项目介绍
          </van-button>
        </van-cell-group>
      </div>
    </div>
  </van-overlay>
</template>
<script>

import { ref, onMounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
export default ({
  setup() {
    const showOverlay = ref(false);
    const showBinging = ref(false);
    const router = useRouter();
    const state = reactive({
      Informed: {
        informedFlag: '',
      }
    });
    const changeInformed = () => {
      router.back();
    }
    onMounted(() => {
      console.log('页面打开')
      state.Informed.informedFlag = false;
    })
    return {
      showOverlay,
      showBinging,
      state,
      changeInformed
    };
  },
})
</script>

<style lang="less" scoped>
.example {
  font-size: 18px;
  display: block;

}

.oddRoundElement {
  border-radius: 12px 12px;
  font-size: 14px;
  margin: 0 20px;
  background: #FFF;
  color: #000;
}

.textTitalIndentation {
  font-size: 14px;
  text-align: left;
  padding-top: 1em;
  padding-right: 1em;
  padding-left: 1em;
}

.textIndentation {
  font-size: 14px;
  text-align: left;
  padding-right: 1em;
  padding-left: 1em;
}

.text2DIndentation {
  font-size: 14px;
  text-align: left;
  text-indent: 2em;
  padding-right: 1em;
  padding-left: 1em;
}

.textIndentationoverlay {
  font-size: 12px;
  text-align: left;
  margin-top: 10px;

}

.spanCheckbox {
  text-align: left;
  margin-top: 10px;

}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 500px;
  height: 400px;
}</style>
